import create from 'zustand';

interface ToastMessageStore {
  message: string;
  isOpen: boolean;
  showToast: (message: string) => void;
  closeToast: () => void;
}

const useGlobalToastMessageStore = create<ToastMessageStore>((set) => ({
  message: '',
  isOpen: false,
  showToast: (message: string) => {
    set({ message, isOpen: true });
  },
  closeToast: () => {
    set({ isOpen: false });
  }
}));

export default useGlobalToastMessageStore;
